import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledSecurityLogosComponent } from "./security-logos-component.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import PictureWithLinkComponent from "components/core/picture-with-link/picture-with-link-component";
import { SecurityLogoLinks } from "/constants/links";
const ISO_LOGO_SRC = "/static/img/footer/iso-logo1.png";
const GDPR_LOGO_SRC = "/static/img/footer/gdpr-logo.png";
const SOC_LOGO_SRC = "/static/img/footer/soc-logo.png";
const HIPAA_LOGO_SRC = "/static/img/footer/hipaa-logo.png";
const ISO = "iso";
const SOC = "soc";
const GDPR = "gdpr";
const HIPAA = "hipaa";
class SecurityLogosComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsxs(StyledSecurityLogosComponent, {
            className: "security-logos-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "gdpr-logo-img-container",
                    onClick: this.goToGdprPage,
                    children: /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
                        src: GDPR_LOGO_SRC,
                        alt: "gdpr",
                        href: SecurityLogoLinks[GDPR]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "iso-logo-img-container",
                    children: /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
                        src: ISO_LOGO_SRC,
                        alt: "iso",
                        href: SecurityLogoLinks[ISO]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "soc-logo-img-container",
                    onClick: this.goToSocPage,
                    children: /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
                        src: SOC_LOGO_SRC,
                        alt: "soc",
                        href: SecurityLogoLinks[SOC]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "hipaa-logo-img-container",
                    onClick: this.goToHipaaPage,
                    children: /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
                        src: HIPAA_LOGO_SRC,
                        alt: "hipaa",
                        href: SecurityLogoLinks[HIPAA]
                    })
                })
            ]
        });
    }
}
export default withGenericConfig(SecurityLogosComponent);
